export default "__VITE_ASSET__TqwcWN6q__"